
<modal-window>
  <h1>
    Add a new Board
  </h1>

  <div class="label mt-2 mb-1">Board Title</div>
  <input type="text" class="form-control" v-model="boardInsertDto.title" />

  <div class="label mt-2 mb-1">Board uses Shifts</div>
  <div class="form-check mb-4">
    <input
      type="checkbox"
      class="form-check-input"
      id="boardUsesShifts"
      v-model="boardInsertDto.enableShifts"
    />

    <label class="form-check-label" for="boardUsesShifts">Board uses Shifts</label>
  </div>

  <template v-slot:sidebar>
    <div class="align-self-end flex-grow-1">
      <button
        class="btn btn-block btn-sm btn-success"
        :disabled="!boardInsertDto.title"
        @click="saveBoard()"
      >
        <i class="far fa-save"></i>
        Save new Board
      </button>
    </div>
  </template>
</modal-window>
